import notifyAfaHistoryReducer from "./notifyAfaHistoryReducer";
import notifyAfaFailReducer from "./notifyAfaFailReducer";

const afaReducers = {
    notifyAfaHistory: notifyAfaHistoryReducer,
    notifyAfaFail: notifyAfaFailReducer
}

export default afaReducers;
